import {readStorage, writeStorage} from '@/core/local-storage/localStorage';

const LANGUAGE_KEY = 'bo:language';
const DEFAULT_LANGUAGE = 'en';

export function readLanguage(): string {
  return readStorage(LANGUAGE_KEY) ?? DEFAULT_LANGUAGE;
}

export function writeLanguage(language: string): void {
  writeStorage(LANGUAGE_KEY, language);
}
